import React from 'react';
import { Users } from 'lucide-react';
import img1 from '../Assests/ashwini.webp';
import img2 from '../Assests/Suniljha.jpg';
import img3 from '../Assests/gufran.jpg';
import img4 from '../Assests/sghosh.jpg';
import img5 from '../Assests/sanjay.jpg';
import jyotiImage from '../Assests/jyoti.jpg';
import sagarImage from '../Assests/sagarbika.jpg';
import sanjeevImage from '../Assests/sanjeev.jpg';

const TeamSection = () => {
  const teamLeaders = [
    {
      name: "Prof. Ashwini K. Agrawal",
      position: "Dean (R&D)",
      image: img1,
      profileLink: "https://textile.iitd.ac.in/faculty-profile/7"
    },
    {
      name: "Prof. Sunil Jha",
      position: "Associate Dean (R&D)",
      image: img2,
      profileLink: "https://mech.iitd.ac.in/faculty-profile/169"
    },
    {
      name: "Prof. Gufran Sayeed Khan",
      position: "Professor (Chairperson)",
      image: img3,
      profileLink: "https://sense.iitd.ac.in/faculty-profile/4"
    },
    {
      name: "Prof. Sudarsan Ghosh",
      position: "Professor (Co-Chairperson)",
      image: img4,
      profileLink: "https://mech.iitd.ac.in/faculty-profile/170"
    },
    {
      name: "Prof. Sanjay Dhir",
      position: "Professor (Co-Chairperson)",
      image: img5,
      profileLink: "https://dms.iitd.ac.in/faculity_type/prof-sanjay-dhir/"
    }
  ];

  const makeDummyImage = (name) =>
    `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=0ea5e9&color=fff&size=240`;

  const sanitizeEmail = (email) => {
    if (!email) return '';
    const cleaned = String(email).split('/')[0].trim();
    return cleaned.includes('@') ? cleaned : '';
  };

  const topMembers = [
    {
      name: 'Mrs. Jyoti Grover',
      designation: 'Dy. Admin. Officer, Office Of the Dean (R&D)',
      image: jyotiImage,
      email: '',
      // isLead: true
    },
    {
      name: 'Mr. Sagar Bika',
      designation: 'Web Team',
      image: sagarImage,
      email: '',
      // isLead: true
    },
    {
      name: 'Mr. Sanjeev',
      designation: 'Web Team',
      image: sanjeevImage,
      email: '',
      // isLead: true
    }
  ];

  const committeeMembers = [
     { name: 'Suman Kumar', designation: 'Web Dev & Data Mgmt', email: 'smz258476@iitd.ac.in' },
    { name: 'Khan Mohd Ehshan Abdul Latif', designation: 'Web Dev & Data Mgmt', email: 'idz248565@iitd.ac.in' },
    { name: 'Lokendra Singh Dangi', designation: 'Coordination', email: 'lokendrasd6@iitd.ac.in' },
    { name: 'Mohd Shanu', designation: 'Demo & 3-Minute Talk', email: 'ird601707@iitd.ac.in' },
    { name: 'Zainab Aziz', designation: 'Demo & 3-Minute Talk', email: 'idz258685@iitd.ac.in' },
    { name: 'Mudra Hemendra Chavda', designation: 'Demo & 3-Minute Talk', email: 'idz218414@iitd.ac.in' },
    { name: 'Abhishek Shandilya', designation: 'Infra & Logistics', email: 'abshandilya@iitd.ac.in' },
    { name: 'Sandeep Rathour', designation: 'Infra & Logistics', email: 'ersandeep06@iitd.ac.in' },
    { name: 'Pankaj Sansanwal', designation: 'Option 3Tshirt, Security & Hospital, Food & Photography (TFP)', email: 'pankaj.sansanwal@mech.iitd.ac.in' },
    { name: 'H B Sidhnath', designation: 'Option 3Tshirt, Food & Photography (TFP)', email: 'smz268023@iitd.ac.in' },
    { name: 'Amit Kumar Tiwari', designation: 'Option 3Tshirt, Food & Photography (TFP)', email: 'atiwari@iitd.ac.in' },
    { name: 'Iqbal Ahmed Ansari', designation: 'Option 3Tshirt, Food & Photography (TFP)', email: 'ird600391@iitd.ac.in' },
    { name: 'Bipin Kumar Yadav', designation: 'Outreach, Registration & Helpdesk', email: 'idy267592@sense.iitd.ac.in' },
    { name: 'Fouzia Kalim', designation: 'Outreach, Registration & Helpdesk', email: 'ird600986@iitd.ac.in' },
    { name: 'Isha Dagar', designation: 'Outreach, Registration & Helpdesk', email: 'ishadagar.iitd@gmail.com' },
    { name: 'Dr. Kausik Chanda', designation: 'Poster, Print & Design', email: 'kausikchanda@sense.iitd.ac.in' },
    { name: 'Wungkhai Hommichon', designation: 'Poster, Print & Design', email: 'smz258478@iitd.ac.in' },
    { name: 'Ashutosh Kumar', designation: 'Poster, Print & Design', email: 'idz268264@iitd.ac.in' },
   
  ].map((member) => ({
    ...member,
    email: sanitizeEmail(member.email),
    image: makeDummyImage(member.name),
    isLead: false
  }));

  const allMembers = [...topMembers, ...committeeMembers];

  const TeamCard = ({ member, index, isLead = false }) => (
    <div 
      className="group relative rounded-2xl p-6 shadow-md hover:shadow-lg transition-all duration-300 border bg-white border-gray-200 hover:border-blue-300"
      style={{
        animationDelay: `${index * 0.1}s`,
        animation: 'fadeInUp 0.6s ease-out forwards'
      }}
    >
      <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-br from-blue-50 to-indigo-50"></div>
      
      <div className="relative z-10">
        {isLead && (
          <div className="flex justify-center mb-4">
            <span className="inline-flex items-center rounded-full bg-yellow-500 text-white text-[10px] font-bold uppercase tracking-[0.18em] px-3 py-1 shadow-sm">
              Team Lead
            </span>
          </div>
        )}

        <div className="relative mb-6">
          <img
            src={member.image || makeDummyImage(member.name)}
            alt={member.name}
            className="w-48 h-48 rounded-full object-cover mx-auto border-3 border-gray-100 group-hover:border-blue-300 shadow-lg transition-all duration-300"
            onError={(e) => {
              e.target.src = makeDummyImage(member.name);
            }}
          />
          <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full border-3 border-white shadow-md bg-green-500"></div>
        </div>

        <div className="text-center">
          <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-700 transition-colors duration-300">
            {member.name}
          </h3>
          {member.designation && (
            <p className="text-sm font-medium text-blue-600 mb-2 group-hover:text-blue-700 transition-colors duration-300">
              {member.designation}
            </p>
          )}
          {member.email && (
            <p className="text-xs text-gray-700 break-words px-2">{member.email}</p>
          )}
        </div>
      </div>
    </div>
  );

  const LeadershipCard = ({ member, index }) => (
    <div
      className="group relative rounded-2xl p-6 shadow-md hover:shadow-lg transition-all duration-300 border bg-white border-gray-200 hover:border-blue-300"
      style={{
        animationDelay: `${index * 0.1}s`,
        animation: 'fadeInUp 0.6s ease-out forwards'
      }}
    >
      <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-br from-blue-50 to-indigo-50"></div>

      <div className="relative z-10">
        <div className="relative mb-6">
          <img
            src={member.image || makeDummyImage(member.name)}
            alt={member.name}
            className="w-48 h-48 rounded-full object-cover mx-auto border-3 border-gray-100 group-hover:border-blue-300 shadow-lg transition-all duration-300"
            onError={(e) => {
              e.target.src = makeDummyImage(member.name);
            }}
          />
          <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full border-3 border-white shadow-md bg-green-500"></div>
        </div>

        <div className="text-center">
          <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-700 transition-colors duration-300">
            {member.name}
          </h3>
          {member.position && (
            <p className="text-sm font-medium text-blue-600 mb-4 group-hover:text-blue-700 transition-colors duration-300">
              {member.position}
            </p>
          )}

          {member.profileLink && member.profileLink !== '/' && (
            <a
              href={member.profileLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-full font-medium transition-all duration-300 shadow-md hover:shadow-lg text-sm"
            >
              <span>View Profile</span>
              <span aria-hidden="true">↗</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 py-20">
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-16 mt-10">
          <div className="inline-flex items-center gap-3 bg-white rounded-full px-6 py-3 shadow-lg mb-6">
            <Users className="w-8 h-8 text-blue-600" />
            <span className="text-blue-600 font-semibold text-lg">Open House 2026</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-gray-800 to-blue-800 bg-clip-text text-transparent mb-6">
            Meet Our Team
          </h1>
          
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-indigo-600 mx-auto mb-6"></div>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Distinguished faculty and organizers working together to make IIT Delhi Open House 2026 
            an exceptional experience for all visitors.
          </p>
        </div>

        {/* Leadership Team */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-4">Leadership Team</h2>
          <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 mx-auto mb-12"></div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 justify-items-center">
            {teamLeaders.map((member, index) => (
              <LeadershipCard key={index} member={member} index={index} />
            ))}
          </div>
        </div>

        {/* Members Section */}
        <div className="mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-12 border border-gray-100">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-4">Team Members</h2>
            <div className="w-16 h-1 bg-gradient-to-r from-indigo-500 to-blue-500 mx-auto mb-12"></div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 justify-items-center">
              {allMembers.map((member, index) => (
                <TeamCard key={`${member.name}-${index}`} member={member} index={index} isLead={member.isLead} />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        /* Responsive adjustments */
        @media (max-width: 1280px) {
          .xl\\:grid-cols-5 {
            grid-template-columns: repeat(4, minmax(0, 1fr));
          }
        }
        
        @media (max-width: 1024px) {
          .lg\\:grid-cols-4 {
            grid-template-columns: repeat(3, minmax(0, 1fr));
          }
        }
        
        @media (max-width: 768px) {
          .md\\:grid-cols-3 {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }
        
        @media (max-width: 640px) {
          .sm\\:grid-cols-2 {
            grid-template-columns: repeat(1, minmax(0, 1fr));
          }
        }
      `}</style>
    </div>
  );
};

export default TeamSection;